(function () {
class $80c31973cfd24c43$var$CourseSelector {
    constructor(el){
        this.el = el;
        this.form = this.el.querySelector("form");
        this.submit = this.form.querySelector("button");
        this.stateSel = this.el.querySelector("#state-select");
        this.licenseSel = this.el.querySelector("#license-select");
        this.options = [
            ...this.licenseSel.options
        ];
        this.init();
    }
    init() {
        this.stateSel.addEventListener("change", this.handleStateSelect.bind(this));
        this.licenseSel.addEventListener("change", this.handleLicenseSelect.bind(this));
        this.form.addEventListener("submit", (e)=>{
            e.preventDefault();
            const ref = this.licenseSel.value;
            window.location.href = ref;
        });
    }
    handleStateSelect(e) {
        const t = e.target;
        const state = t.value;
        this.licenseSel.removeAttribute("disabled");
        this.filterLicenseOptions(state);
    }
    handleLicenseSelect(e) {
        const t = e.target;
        const ref = t.value;
        let url;
        if (ref.includes("https")) url = new URL(ref);
        else url = window.location + ref;
        if (url) this.submit.removeAttribute("disabled");
    }
    filterLicenseOptions(state) {
        this.licenseSel.innerHTML = "";
        this.options.forEach((o)=>{
            if (o.dataset.state && o.dataset.state == state || o.disabled) this.licenseSel.append(o.cloneNode(true));
        });
    }
}
window.addEventListener("DOMContentLoaded", ()=>{
    let courseSelectors = document.querySelectorAll(".course-selector");
    courseSelectors.forEach((c)=>{
        new $80c31973cfd24c43$var$CourseSelector(c);
    });
});

})();
//# sourceMappingURL=courseSelector.js.map
